import React from "react";
import telegramChannelLogo from "../../../assets/images/telegram-channel.png";

import { StyledTelegramChannelWrapper } from "./styledTelegramChannel";

const TelegramChannel = ({ t }) => {

  return (
    <StyledTelegramChannelWrapper>
      <div className="telegram-logo">
        <a href="https://t.me/+ijgQuonZwwYyZTM6" target="_blank">
          <img src={telegramChannelLogo} alt="channel-logo" />
        </a>
      </div>
      <div className="telegram-title">
        CP Channel For Customers
      </div>
      <div className="telegram-description">
        {t("telegram.descriptions")}
      </div>
      <div className="telegram-action">
        <a href="https://t.me/+ijgQuonZwwYyZTM6" target="_blank">
          {t("telegram.link")}
        </a>
      </div>
    </StyledTelegramChannelWrapper>
  );
};

export default TelegramChannel;